// @flow

import * as React from 'react';
import { observer } from 'mobx-react';
import Config from '@insolus/config';
import I18n from '@insolus/i18n';
import { useTranslate } from '@insolus/react-i18n';
import authStore from 'stores/auth';
import __p from 'utils/__p';
import Header from '../../components/Header';
import useRedirect from 'hooks/useRedirect';
import useLogout from 'hooks/useLogout';

const HeaderElement = (): React.Node => {
    const { __ } = useTranslate();
    const redirect = useRedirect();
    const logout = useLogout();

    const nav = [
        {
            icon  : 'star',
            title : __('bookmarks'),
            url   : __p('/account/bookmarks')
        }
    ];

    // #142 Ajustements temporaire dans le menu
    // TODO: Remettre en place les liens avec les tickets #52 et #53

    // const nav = [
    //     {
    //         icon  : 'bell',
    //         title : __('my-searches'),
    //         url   : __p('/')
    //     }
    // ];

    let userNav = {
        icon  : 'user',
        title : __('login'),
        url   : __p('/login')
    };
    if (authStore.isLogged && authStore.user) {
        const { user } = authStore;

        const userNavChildren = [];

        if (authStore.is('admin')) {
            userNavChildren.push({
                icon    : 'tools',
                title   : __('admininistration'),
                onClick : redirect('/admin', { static: true })
            });
        }

        userNavChildren.push({
            icon    : 'home',
            title   : __('account'),
            onClick : redirect(__p('/account'))
        });

        userNavChildren.push({
            icon    : 'exit',
            title   : __('logout'),
            onClick : logout
        });

        userNav = {
            icon  : 'user',
            title : (user.profile && user.profile.displayName)
                ? user.profile.displayName
                : user.email,
            children: userNavChildren
        };
    }
    nav.push(userNav);

    const languages = Config.get('language.list');
    const names = Config.get('language.names');
    const defaultLanguage = Config.get('language.default');
    const currentLanguage = I18n.language;

    nav.push({
        title    : currentLanguage,
        children : languages
            .filter(language => language !== currentLanguage)
            .map(language => ({
                title   : names[language],
                onClick : redirect(
                    `/${language === defaultLanguage ? '' : language}`,
                    { static: true }
                )
            }))
    });

    return <Header nav={nav} />;
};

export default (observer(HeaderElement): typeof HeaderElement);
